import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import TableIconModal from "../../../shares/TableIconModal";

// import Others files

const RemoveCity = (props) => {
  let windowWidth = window.screen.width;
  const [editedName, setEditedName] = useState();
  const [openModal, setOpenModal] = useState(false);

  const RemoveCityApi = useFetch({
    method: "delete",
    url: `City_Service/${props.selectedRow?.id}`,

    trigger: false,
    argFunc: (res) => {
      props.getCitiesApi.reFetch();
      // toast.success("شهر موردنظر با موفقیت حذف شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از حذف شهر اطمینان دارید؟"
        icon={<DeleteIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={RemoveCityApi.reFetch}
      ></TableIconModal>
    </>
  );
};

export default RemoveCity;
